import { render, staticRenderFns } from "./SubproyectosCreateUpdate.vue?vue&type=template&id=59184683"
import script from "./SubproyectosCreateUpdate.vue?vue&type=script&lang=js"
export * from "./SubproyectosCreateUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports